interface Params {
  vin?: string | null;
  year?: string | null;
  make?: string | null;
  model?: string | null;
  ageRangeFilter?: string | null;
  kilometersRangeFilter?: string | null;
  bodyTypeRangeFilter?: string | null;
}

export default function validateRequiredRangedRatesCallFields(
  params: Params
): boolean {
  const hasVin = Boolean(params.vin);
  const hasYmm =
    Boolean(params.year) && Boolean(params.make) && Boolean(params.model);
  const hasFilters =
    Boolean(params.ageRangeFilter) &&
    Boolean(params.kilometersRangeFilter) &&
    Boolean(params.bodyTypeRangeFilter);

  // Accept if there's a VIN, YMM, or ALL filters
  return hasVin || hasYmm || hasFilters;
}
